import React, { Component } from 'react';
import { Form, Button, Col, Container,Row } from 'react-bootstrap';
import { endPoints } from "../../constant/Environment";
import { useNavigate } from "react-router-dom";

class BlockListSearch extends Component{
    constructor(props) {
        super(props);
        console.log(props);
      }
    state = {
        name: "",
        platform:"1",
        status:"",
        regdate: "",
        state: "",
        city: "",
        accounNumber:""
      };
      
      addNew = () => {
       this.props.addNew();
      }
      searchList = () => {
        this.props.searchList(this.state);
       }
      
    exportCsv = (e) => {
        e.preventDefault();
        var body = {
            name: this.state.name,
            platform: this.state.platform,
            status:true,
            regdate: this.state.regdate,
            state:this.state.state,
            city:this.state.city,
            accounNumber:this.state.accounNumber
        }
    
        fetch(`${endPoints.apiBaseUrl+endPoints.api.USERS_BLOCK_REPORT+'/csv'}`, {
                    method: 'POST',
                    body: JSON.stringify(body),
                    responseType: 'blob',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                }).then(function(response) {
                    response.blob().then(blob => {
                        const link = document.createElement('a');
                        const url = URL.createObjectURL(blob);
                        console.log(url);
                        link.href = url;
                        link.download = 'BlockListReport.csv';
                        link.click();
                    })
                   
                });
    };
    exportPdf = (e) => {
        e.preventDefault();
        var body = {
            name: this.state.name,
            platform: this.state.platform,
            status:true,
            regdate: this.state.regdate,
            state:this.state.state,
            city:this.state.city,
            accounNumber:this.state.accounNumber
        }
        fetch(`${endPoints.apiBaseUrl+endPoints.api.USERS_BLOCK_REPORT+'/pdf'}`, {
                    method: 'POST',
                    body: JSON.stringify(body),
                    responseType: 'blob',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                }).then(function(response) {
                    response.blob().then(blob => {
                        const link = document.createElement('a');
                        const url = URL.createObjectURL(blob);
                        console.log(url);
                        link.href = url;
                        link.download = 'BlockListReport.pdf';
                        link.click();
                    })
                });
    };
    render() {
        return( <Container fluid>
                    <Form>
                    <Row>
                   
   <Col>
                            <Form.Group as={Col} controlId="formName">
                                <Form.Label className="label">Name</Form.Label>
                                <Form.Control
                                type="text"
                                value={this.state.name}
                                onChange={e => this.setState({ name: e.target.value })}
                                name="name"
                                />
                            </Form.Group>
                            </Col>
                           
                            <Col>
                            <Form.Group as={Col} controlId="formLastName">
                                <Form.Label className="label">From Date</Form.Label>
                                <Form.Control
                                type="date"                           
                                name="date"
                                value={this.state.regdate}
                                onChange={e => this.setState({ regdate: e.target.value })}
                           
                                />
                            </Form.Group>
                            </Col>
                       
                            <Col>
                            <Form.Group as={Col} controlId="formLastName">
                                <Form.Label className="label">To Date</Form.Label>
                                <Form.Control
                                type="date"                           
                                name="date"
                                value={this.state.regdate}
                                onChange={e => this.setState({ regdate: e.target.value })}
                           
                                />
                            </Form.Group>
                            </Col>
                        <Col>
                            <Form.Group as={Col} controlId="formCity">
                                <Form.Label className="label">City</Form.Label>
                                <Form.Control
                                type="text"                           
                                name="city"
                                value={this.state.city}
                                onChange={e => this.setState({ city: e.target.value })}
                           
                                />
                            </Form.Group>
                            </Col>  
                            <Col>
                            <Form.Group as={Col} controlId="formState">
                                <Form.Label className="label">State</Form.Label>
                                <Form.Control
                                type="text"                           
                                name="state"
                                value={this.state.state}
                                onChange={e => this.setState({ state: e.target.value })}
                           
                                />
                            </Form.Group>
                            </Col>
                        </Row>
                        
                        <Row>
                        <Col><Form.Group as={Col} controlId="formAccount">
                                <Form.Label className="label">Account Number</Form.Label>
                                <Form.Control
                                type="text"                           
                                name="account"
                                value={this.state.accounNumber}
                                onChange={e => this.setState({ accounNumber: e.target.value })}
                                />
                            </Form.Group></Col>
                        
                                <Col><Form.Group as={Col} controlId="formAccount">
                                <Form.Label className="label">Account Status</Form.Label>
                                <Form.Select                    
                                name="platform"
                                value={this.state.status}
                                onChange={e => this.setState({ status: e.target.value })}                           
                                >
                        <option value="">All</option>
                        <option value="1">Active</option>
                        <option value="2">Inactive</option>
                        <option value="3">Suspended</option>
                        <option value="34">Block</option>
                        
                                </Form.Select>
                            </Form.Group></Col>                
                            <Col>
                            <Form.Group as={Col} controlId="formPlatform">
                            <Form.Label className="label">Platform</Form.Label>
                            <Form.Select                    
                                name="platform"
                                value={this.state.platform}
                                onChange={e => this.setState({ platform: e.target.value })}                           
                                >
                                    
                        <option value="1">All</option>
                        <option value="2">WEB</option>
                        <option value="3">MOBILE</option>
                                </Form.Select>
                            </Form.Group>
                            </Col>
                            <Col>
   <Button className='exportbtn' onClick={this.exportPdf}>
   <img src="/images/icons/pdf.png" />
   </Button>
    
   <Button className='exportbtn' onClick={this.exportCsv}>
   <img src="/images/icons/csv.png" />
   </Button>
  </Col>  <Col>
                        <Button variant="primary" onClick={this.searchList}>Search</Button>
                      
                        <Button variant="primary" className='mrglft10' onClick={this.addNew}>Add</Button>
                        </Col>
                       
                        </Row>
                    </Form>
                </Container>
        );
    }
}

export default BlockListSearch;